/* eslint-disable no-case-declarations */
/* eslint-disable one-var */
/* eslint-disable camelcase */

import { computeWatchDur, getHostFromUrl, generateSessionId, isType, log, getResponseHeaders, nowTime, curTimestamp, formatData, checkVideoSrcIsEmpty, checkIsEmptySrc, transformHeader, parseTempData } from './utils/util'
import { findPerformanceInfo } from './utils/connect'
import Collector from 'byted-tea-sdk/es/CollectorBaseClient.min.js'
import LocalLog from './utils/locallog'
import Browser from './utils/browser'
import SpeedCheckTask from './utils/speedtask'
import version from './version'

log(`logger version is ${version}`)

const isObject = isType('Object')
const REPORT_EVENTS = {
  ONE_PLAY: 'videoplayer_oneplay',
  ONE_OPERA: 'videoplayer_oneopera',
  ONE_ERROR: 'videoplayer_oneerror',
  ONE_EVENT: 'videoplayer_oneevent',
  ONE_TEMP: 'videoplayer_onetemp'
}

const ERROR_TYPES = {
  data: 1000, // 数据错误导致的异常
  runtime: 1002,
  parse: 1004,
  network: 1003,
  no_error_handler: 9997,
  custom_error: 9998,
  other: 9999,
  notSupport: 1005 // 浏览器不支持导致
}

const ERROR_CODES = {
  1: -499991,
  2: -499992,
  3: -499993,
  4: -499994,
  5: -499995
}

const PLAYBACK_STATE = {
  STOP: 0,
  PLAYING: 1,
  PAUSE: 2,
  ERROR: 3,
  LOADING: 4
}

const LOAD_STATES = {
  UNKNOWN: 0,
  PLAYABLE: 1,
  STALLED: 2,
  ERROR: 3
}

// 结束类型
const ENDED_TYPE = {
  ERROR: 1,
  NEXT: 2,
  ENDED: 3,
  UNLOAD: 4,
  DESTROY: 5,
  PLAY_CATCH: 6
}

const LOGTYPES = {
  RETRY: 'error_retry',
  ONEERROR: 'oneerror',
  ONEEVENT: 'oneevent',
  ONETEMP: 'onetemp'
}

const CACHE_FILE_TYPE = {
  NO_CACHE: 0,
  CACHED: 1
}

let TEA_ID = 1300
let LS_KEY = `__tea_cache_tokens_${TEA_ID}`
const DEFAULT_INTERVAL = -1

const MAX_TIME = 12 * 60 * 60 * 1000 // 时差计算类的脏数据阈值，超过该值置空，避免时间戳类的脏数据导致数据结果异常
const MAX_COST = 60 * 1000 * 60;
// 外部传入的公共参数
const COMMON_KEYS = ['vtype', 'tag', 'subtag', 'codec_type', 'device_type']

// 卡顿最短触发时间间隔 ms
const MIN_WAITIONG = 200

// seek和卡顿超时时间间隔 ms
const MAX_STALL_TIME = 60 * 1000

class XGPlayerAppLogger {
  static set TEA_ID (value) {
    TEA_ID = value
    LS_KEY = `__tea_cache_tokens_${TEA_ID}`
  }

  static get TEA_ID () {
    return TEA_ID
  }

  constructor (player, options) {
    this.player = player
    if (this.player === undefined || this.player === null) {
      throw new Error(`player is ${this.player}`)
    }
    if (!options || !options.line_app_id) {
      console.warn('player.config.vodLogOpts.line_app_id is necessary for plugin xgVodLogger')
      return;
    }
    this.sniffer = this.player.constructor.sniffer || this.player.constructor.Sniffer
    this.util = this.player.constructor.util || this.player.constructor.Util
    if (this.sniffer === undefined || this.util === undefined) {
      throw new Error('player should be an instane from xgplayer, need sniffer and util interface')
    }
    // 网络检测任务开启
    (options.isTask || options.isTask === undefined) && (this.task = new SpeedCheckTask())
    this.eventQueue = []
    this._instanceCreateTime = new Date().getTime()
    options.codec_type = options.codec_type || 'h264'
    this._options = options
    !this._options.maxQueueCount && (this._options.maxQueueCount = 5)
    this.line_app_id = parseInt(options.line_app_id, 10) || 0
    this.line_user_id = (options.line_user_id || '').toString()
    this.version = version
    this.sdk_version = version
    this.playerCoreVersion = options.playerCoreVersion || ''
    this.playerVersion = options.playerVersion || options.sdk_version
    this.closeSeekLog = options.closeSeekLog || false
    this.start_time = (options.start_time || 0) * 1000
    this.isFullAB = options.isFullAB || false
    this._initial_resolution = ''
    this.__vtype = null
    this.__dt = '' // dash类型
    this.isLowMp4 = false // 是否是经过dash降级的mp4
    this.resetLoggerParams()
    try {
      this.initializeTracker()
      this.sendLocalLog()
      this.bindEvt()
      log('logger constructor:' + this.player.video)
    } catch (e) {
      console.log(e)
    }
  }

  resetLoggerParams () {
    log('resetLoggerParams')
    const lc = this.playlogs ? this.playlogs.lc : 0
    this.playlogs = {
      nt: curTimestamp(), // sdk初始化的时间点
      vt: 0, // 起播时间
      rt: this.isEnded ? curTimestamp() : 0, // 播放器准备完成时间
      at: 0, // api_time,  play接口获取视频列表结束的时间戳，单位是毫秒；
      pt: 0, // 触发播放流程时间 (this.isEnded || this.player.config.autoplay) ? new Date().getTime() : 0,
      bu_acu_t: 0, // 累计网络卡顿时长
      bc: 0, // 网络卡顿次数
      br: 0, // 中断次数
      fbrt: '', // 首次中断类型
      dbc: 0, // 解码卡顿次数
      de_bu_acu_t: 0, // 累计解码卡顿时长
      nbc: 0, // 网络卡顿次数
      n_bu_acu_t: 0, // 累计网络请求卡顿时长
      played: [{ begin: 0, end: -1 }], // 累计播放记录
      dash_pst: 0, // dash_state: player_start
      dash_wst: 0, // dash_state: wasm_start
      dash_wrt: 0, // dash_state: wasm_ready
      dash_ift: 0, // dash_state: init_finished
      dash_cst: 0, // dash_state: core_start
      dash_spt: 0, // dash_state: start_play
      interruptCount: 0, // error retry count
      degrade: 'none', // 降级类型 dash2dash_backup-dash备用地址降级 mp42dash-mp4降级为dash dash2mp4-dash降级mp4
      lc
    }

    // 上次发生降级的时候的数据
    this.degradeLog = {
      bu_acu_t: 0,
      bc: 0,
      watch_dur: 0,
      hasSendEnd: false
    }

    this.buffers = {
      allBuffer: [],
      curBuffer: {
        buf_s_pos: 0, // 缓存开始点
        buf_e_pos: 0, // 缓存结束点
        buf_include: 0 // 当前缓存是否包含当前播放时间
      }
    }

    this.netLog = {
      downloadSpeed: 0, // 网络请求速度
      requestCount: 0, // 网络请求次数
      connectCost: 0, // 平均网络连接耗时 ms
      totalSpeed: 0, // 下载速度累加
      rqCount: 0, // 一次播放行为中
      status: 0 // 最后一次请求的httpcode
    }

    this.merror = {
      // "针对main url的错误信息
      cdn: [], // 请求失败的cdn信息
      player: [], //  //main_url的player失败信息 // ijk 播放失败
      playCatch: [],
      expied: []
    }

    this.exInfo = {
      buffer: {}, // 缓存信息
      stall: [] // 卡顿信息
    }

    this._templog = null

    this._isOnePlayReport = false
    this.startStep = 0
    this.bft = 0
    this.initializeLogDatas()
    this.initializeUrlLog()
  }

  initializeLogDatas () {
    this.startStep = 0
    this.inWaitingStart = 0
    this.lastVideoTime = 0
    // -------common params-------
    this._endType = '' // 结束类型
    this._retryCount = 0 // 内部重试次数 目前播放器没有重试逻辑
    // event
    this.lastOperaTime = DEFAULT_INTERVAL
    this.lastEventTime = DEFAULT_INTERVAL
    this.seekLog = {
      intervalId: 0,
      lastSeekStartTime: nowTime(),
      seekBefore: 0,
      sat: 0, // 累计seek时长
      sc: 0 // seek的次数
    }
    // 分辨率，清晰度相关
    this.resLogs = {
      lastSwitchStartTime: DEFAULT_INTERVAL, // 上一次切换清晰度的时间戳
      switch_count: 0, // 切换次数
      abr_switch_count: 0,
      initial_resolution: '', // 初始清晰度
      final_resolution: '', // 最终清晰度
      ldst: 0, // 最后一次切换分辨率开始时间
      ldet: 0, // 最后一次切换分辨率完成时间
      df: '', // 清晰度
      lf: '', // 切换前清晰度
      played: [],
      bc: 0, // 累计卡顿次数
      bu_acu_t: 0,
      sc: 0, // 累计seek次数
      sat: 0, // 累计seek耗时
      buf: 0, // 累计缓存时长
      lbuf: 0, // 上一次缓存的时长
      lplayed: 0, // 上一个清洗播放的时长
      vs: 0, // 当前视频大小
      vds: 0, // 当前下载大小
      vps: 0, // 当前播放过的数据大小
      vis: 0, // vs/duration
      bitrate: 0 // 比特率
    }
    this.apiLog = {
      code: 0,
      message: '',
      logid: '',
      api: '',
      auth: '',
      error: {}
    }
    this.errorLog = {
      accu_errc: 0, // 累计错误次数
      try_err_c: 0, // 错误重试次数，重试成功清零
      errt: 0,
      errc: 0,
      fir_errt: 0,
      fir_errc: !Browser.isSupportMP4 ? 1005 : 0, // 试验 暂用字段
      last_errors: []
    }
    this.pauseLog = {
      pause_acu_t: 0, // 累计暂停时长
      isPausing: false,
      pause_start: 0
    }
    // stall
    this.stall = {
      intervalId: 0,
      stall_count: 0,
      first_buf_startt: 0, // 第一次卡顿开始
      first_buf_endt: 0, // 第一次卡顿结束
      stall_start: 0, // 一次开始时间
      stall_end: 0, // 一次结束
      stall_last_interval: 0, // 最近一次stall时长
      stall_acc_time: 0 // 多次累计
    }
    this._playerCreatedTime = 0
    this.load_state = LOAD_STATES.UNKNOWN
    this.lv_method = 6
    // 当前是否在seek中
    this.isSeeking = false
    // 当前是否播放结束
    this.isEnded = false
    // 首帧是否开始 0-未开始播放 1-onplay 但是首帧未出来 2-首帧已经ok
    this.startStep = 0
    this.isAutoplay = this.player.config && this.player.config.autoplay ? 1 : 0

    // 动态码率相关日志
    this.abrInfo = {
      abr_general_info: {},
      abr_event_info: {
        video_switch: [],
        video_stall: [],
        video_exit: {}
      },
      abr_play_info: {
        start_play_time_ms: 0,
        is_hint: 0,
        playback_info: {
          internet_speed_record: [],
          play_bitrate_record: [],
          buffer_length_record: [],
          play_speed_record: []
        }
      },
      abr_user_info: {
        cancel_abr: 0
      },
      abr_init_opts: this.player.config.autoBitrateOpts || {}
    }
    // 是否命中 预加载缓存 的标识
    this._cacheFile = CACHE_FILE_TYPE.NO_CACHE;
  }

  initSessionId () {
    let webId = '0'
    try {
      const data = window.localStorage.getItem(LS_KEY)
      webId = data.web_id || '0'
    } catch (error) {
      webId = '0'
    }
    this._sessionId = generateSessionId(webId)
    log(`sessionId ${this._sessionId}`)
  }

  initializeUrlLog = (value) => {
    let initialUrl = value || ''
    if (typeof (initialUrl) !== 'string') {
      initialUrl = ''
    }
    this.urlLog = {
      initial_url: initialUrl,
      initial_host: getHostFromUrl(initialUrl),
      initial_ip: ''
    }
  }

  initializeTracker () {
    const { _options } = this
    if (!window.__xgplayer_vod_log__) {
      this.tracker = window.__xgplayer_vod_log__ = new Collector('tracker')
      let channel = _options.channel || 'cn'
      channel = channel === 'va' || channel === 'sg' ? channel : 'cn'
      const config = {
        app_id: channel === 'cn' ? TEA_ID : (TEA_ID === 1300 ? 3063 : TEA_ID),
        channel: channel,
        log: false,
        disable_sdk_monitor: true
      }
      if (_options.channelDomain) {
        config.channel_domain = _options.channelDomain
      }
      // ab实验开关
      config.enable_ab_test = !!_options.enableAbTest
      // 初始化Tea日志上报组件
      this.tracker.init(config)
    } else {
      this.tracker = window.__xgplayer_vod_log__
    }

    this.initSessionId()
    // 日志公共参数
    this.commonParams = {
      play_type: 0, // 点播
      source_type: 'vid',
      sdk_version: this.sdk_version,
      pc: this.playerCoreVersion,
      pv: this.playerVersion,
      line_app_id: this.line_app_id,
      line_user_id: this.line_user_id,
      absdkVersion: _options.absdkVersion || '',
      app_version: _options.appVersion || '',
      platform: Browser.isPad ? 'pad' : (Browser.isMobile ? 'mobile' : 'pc') // 平台类型
    }
    log('commonParams ', this.commonParams)
    const trackConfig = {
      evtParams: this.commonParams,
      disable_auto_pv: true
    }
    log('Browser.name ', Browser.name)
    if (Browser.name && !Browser.isChrome && !Browser.isSafari) {
      trackConfig.browser = Browser.name
      Browser.appVersion && (trackConfig.browser_version = Browser.appVersion)
    }
    if (this.line_user_id) {
      trackConfig.user_unique_id = this.line_user_id
      trackConfig.web_id = this.line_user_id
    }
    // ab实验id获取
    const abVersion = _options.absdkVersion || ''
    if (abVersion) {
      trackConfig.ab_sdk_version = abVersion
    }
    if (_options.referrer) {
      trackConfig.referrer = _options.referrer
      trackConfig.referrer_host = getHostFromUrl(_options.referrer)
    }
    this.tracker.config(trackConfig)
    this.tracker.start()
  }

  resetDefiInfo () {
    const { resLogs } = this
    resLogs.played = []
    resLogs.bc = 0// 累计卡顿次数
    resLogs.bu_acu_t = 0
    resLogs.sc = 0
    resLogs.sat = 0
  }

  /**
   * 初始化的时候将本地记录的日志内容发出去,并将当前记录的内容移除
   */
  sendLocalLog () {
    const data = LocalLog.get()
    LocalLog.remove()
    data.map((item) => {
      Object.keys(item).map((key) => {
        log('sendLocalLog', key, item[key])
        if (this.player) {
          this.player.emit('abLog', key, item[key])
          const sendLocalCallback = this._options.sendLocalCallback
          if (sendLocalCallback && typeof sendLocalCallback === 'function') {
            sendLocalCallback(key, item[key])
          }
        }
        this.tracker(key, item[key])
      })
    })
  }

  bindEvt () {
    this.listeners = [
      { evt: 'play', handler: this.onPlay },
      { evt: 'playing', handler: this.onPlaying },
      { evt: 'pause', handler: this.onPause },
      { evt: 'waiting', handler: this.onWaiting },
      { evt: 'playInterfaceInfo', handler: this.onPlayInterfaceInfo },
      { evt: 'DRM_ERROR', handler: this.onDashError },
      { evt: 'ended', handler: this.onEnded },
      { evt: 'loadeddata', handler: this.onLoadeddata },
      { evt: 'loadstart', handler: this.onLoadStart },
      { evt: 'canplay', handler: this.onCanplay },
      { evt: 'dashStateChange', handler: this.onDashStateChange },
      { evt: 'autoplay was prevented', handler: this.onNotAutoPlay },
      // { 'evt': 'routechange', handler: this.onUserLeave },
      { evt: 'seeking', handler: this.onSeeking },
      { evt: 'seeked', handler: this.onSeeked },
      { evt: 'complete', handler: this.onPlayerInited },
      { evt: 'timeupdate', handler: this.onTimeUpdate },
      { evt: 'bufferedChange', handler: this.onBufferedChange },
      { evt: 'beforeDefinitionChange', handler: this.onBeforeDefinitionChange },
      { evt: 'definitionChange', handler: this.onDefinitionChange }, // 清晰度改变
      { evt: 'definitionChangeSuccess', handler: this.onDefiChangeSuccess }, // 清晰度改变
      { evt: 'drmTypeChange', handler: this.onDrmTypeChange }, // drm_type改变
      { evt: 'replayBtnClick', handler: this.onReplayBtnClick }, // 重播是否处理
      { evt: 'initialUrl', handler: this.initializeUrlLog },
      { evt: 'ABR_CHANGE', handler: this.onAbrChange }, // ABR 自动档位发生变化，进行日志记录
      { evt: 'playCatch', handler: this.onPlayCatch },
      { evt: 'MEDIA_EXPIRED', handler: this.onMediaExpied },
      { evt: 'log', handler: this.onLog },
      // {'evt':'ABR_LOOP', handler: this.onAbrLoop}, //ABR 抽样记录abr每次调用参数
      { evt: 'ABR_PRESTALL_END', handler: this.onAbrPrestallEnd }, // abr档位第一次码率下降后，用户操作结果
      { evt: 'progress_event', handler: this.onProgressEvent },
      { evt: 'logger_next', handler: this.onNext },
      { evt: 'nextEnded', handler: this.onNextEnded },
      { evt: 'media_format_error', handler: this.onMediaFormatError }
    ]
    const errorKey = this.player.config.errorKey
    log('>>>errorKey', errorKey)
    const errorEvt = { evt: 'error', handler: this.onPlayerError }
    if (errorKey) {
      errorEvt.evt = errorKey
    }
    this.listeners.push(errorEvt)
    this.listeners.forEach(item => {
      this.player.on(item.evt, item.handler)
    })
    // this.bindExtra()
    this.bindUnload()
  }

  onMediaFormatError = error_info => {
    this.onOneEvent({
      end_type: (error_info.error_type || '') + 'Error'
    })
  }

  // eslint-disable-next-line camelcase
  onDrmTypeChange = (drm_type) => {
    this.addIfExist('drm_type', { drm_type }, this._options)
  }

  addIfExist (paramsKey, context, params) {
    if (!isObject(context)) {
      return
    }
    const val = context[paramsKey]
    const isExist = !(val === undefined || val === null)
    if (isExist) {
      params[paramsKey] = val
    }
  }

  onReplayBtnClick = () => {
    this.resetLoggerParams()
  }

  onBeforeDefinitionChange = () => {
    this.resLogs.ldst = nowTime()
    this._endType = 'switch'
  }

  onDefinitionChange = ({ from, to }) => {
    this.changeResolution(from, to, this.resLogs.ldst, 'switch')
    log(`onDefinitionChange from:${from}, to:${to}`)
  }

  onDefiChangeSuccess = () => {
    log('onDefinitionChangeSuccess')
    this.updateVideoSize()
    this.triggerTask('start')
  }

  onAbrChange = ({ prev, cur, abrInfo }) => {
    if (this.player.abrInstance) {
      const data = this.player.abrInstance.eventInfo
      log('abrChange', data)
      data.last_definition = prev
      data.now_definition = cur
      this.abrInfo.abr_event_info.video_switch.push(data)
      this.changeResolution(prev, cur, nowTime(), 'abr_switch', abrInfo)
    }
  }

  onAbrPrestallEnd = (stop) => {
    this.abrInfo.abr_user_info.cancel_abr = stop ? 1 : 0
  }

  changeResolution (from, to, startTime, operaType, abrInfo) {
    const { resLogs } = this
    from = from ? from.replace('P', 'p') : ''
    to = to ? to.replace('P', 'p') : ''
    resLogs.ldet = nowTime()
    resLogs.df = to
    resLogs.lf = from
    resLogs.final_resolution = to
    resLogs.switch_count++
    const costTime = resLogs.ldet - startTime
    const ext = {
      bc: resLogs.bc,
      bu_acu_t: resLogs.bu_acu_t,
      sc: resLogs.sc,
      sat: resLogs.sat,
      watch_dur: computeWatchDur(resLogs.played)
    }
    if (abrInfo) {
      ext.abrInfo = abrInfo;
    }
    this.updateVds()
    this.resetDefiInfo()
    if (!this._options.closeResolutionLog) {
      this.onOneOperator({ costTime, operaType, stateBefore: from, stateAfter: to }, ext, 0)
    }
  }

  onTimeUpdate = () => {
    // seek操作到play过程中会调用一次timeUpdate，增加重置条件
    const { playlogs, resLogs, player, errorLog } = this
    // 重试起播，清空重试次数
    errorLog.try_err_c = 0

    if (!playlogs.vt && this.startStep === 1) {
      playlogs.vt = curTimestamp()
      log('onTimeUpdate: first frame inited', `currentTime11:${player.currentTime} vt-pt:${(playlogs.vt - playlogs.pt)} vt-nt:${playlogs.vt - playlogs.nt} vt-rt:${playlogs.vt - playlogs.rt}`)
      this.startStep = 2
    }
    if (!resLogs.initial_resolution) {
      resLogs.initial_resolution = ((player.currentDefitionFromPlayer && player.currentDefitionFromPlayer.definition) ? player.currentDefitionFromPlayer.definition : (player.config.defaultDefinition || (player.video.videoHeight + 'p') || '')).replace('P', 'p')
    }
    if (!resLogs.final_resolution) {
      resLogs.final_resolution = resLogs.initial_resolution
    }
    const len = playlogs.played.length
    if (len < 1) {
      playlogs.played.push({
        begin: player.currentTime,
        end: -1
      })
    } else {
      playlogs.played[len - 1].end = player.currentTime
    }

    const dLen = resLogs.played.length
    if (dLen < 1) {
      resLogs.played.push({
        begin: player.currentTime,
        end: -1
      })
    } else {
      resLogs.played[dLen - 1].end = player.currentTime
    }
    this.lastVideoTime = player.currentTime || 0
    this.updateCurBuffer()
  }

  onCanplay = () => {
    log('onCanplay', `this.startStep:${this.startStep} ${curTimestamp()}`)
    this.setVt()
  }

  onLoadeddata = () => {
    log('onLoadeddata', `this.startStep:${this.startStep} ${curTimestamp()}`)
    this.setVt()
    this.updateVideoSize()
  }

  onLoadStart = () => {
    const isSrcEmpty = checkVideoSrcIsEmpty(this.player.currentSrc) || checkIsEmptySrc(this.player, this.line_app_id)
    this.triggerTask('start')
    log('onLoadStart', `this.startStep:${this.startStep} ${curTimestamp()} isSrcEmpty:${isSrcEmpty} player.src:${this.player.src}`)
    if (this.startStep === 0 && !isSrcEmpty && document.visibilityState === 'visible') {
      this.setPt()
    }
  }

  onDashStateChange = state => {
    log('onDashStateChange', `this.startStep:${this.startStep} ${nowTime()} state:${state}`)
    const { playlogs } = this
    if (this.startStep < 2) {
      switch (state) {
      case 'player_start':
        playlogs.dash_pst = nowTime()
        break;
      case 'wasm_start':
        playlogs.dash_wst = nowTime()
        break;
      case 'wasm_ready':
        playlogs.dash_wrt = nowTime()
        break;
      case 'init_finished':
        playlogs.dash_ift = nowTime()
        break;
      case 'core_start':
        playlogs.dash_cst = nowTime()
        break;
      case 'start_play':
        playlogs.dash_spt = nowTime()
        break;
      }
    }
  }

  onBufferedChange = () => {
    const buffered = this.player.video && this.player.video.buffered // 最后一个缓冲视频范围的结尾，即缓冲完成的时长 单位s, X1000转换为ms
    if (buffered) {
      const len = buffered.length
      if (len > 0 && buffered.end(len - 1) + 1 > this.player.duration) {
        this.bft = curTimestamp()
      }
    }
  }

  onPlayerInited = () => {
    log('player init')
    this._playerCreatedTime = curTimestamp()
    this.playlogs.rt = curTimestamp()
  }

  onNotAutoPlay = () => {
    log('onNotAutoPlay', `autoplay:${this.isAutoplay}`)
    this.isAutoplay = 0
  }

  onDashError = (err) => {
    err = err || {}
    const { errorLog } = this
    errorLog.last_errors.push(err.errorCode)
    errorLog.accu_errc++
    this.onOneError({
      errorType: err.errorTypeCode,
      code: err.errorCode,
      url: err.url || '',
      headers: err.headers || {}
    }, 0)
  }

  /** *Player内部错误上报 */
  onPlayerError = (err) => {
    err = err || {}
    const { errorLog, player, line_app_id } = this
    log('onPlayerError', `this.player.type:${this.player.type} this.player.replayRunning:${this.player.replayRunning} isSupportMP4:${Browser.isSupportMP4} isPC:${Browser.isPC}`)
    log('onPlayerError', err)
    this.load_state = LOAD_STATES.ERROR
    this._endType = 'error'
    this.suspendWaitingStatus('onPlayerError')
    // 加密dash在重播/切换视频的时候会报错，但是可以重新开始播放，忽略该情况下产生的错误
    if (player.type === 'dash' && player.replayRunning) return
    const currentSrc = this.player.currentSrc
    if (!err.url) {
      err.url = currentSrc
    }
    // 当前浏览器不支持h264 只上报错误信息， 不计入vv
    if (((line_app_id === 1768 || line_app_id === 9999) && Browser.isPC && !Browser.isSupportMP4) || Browser.isSpider) {
      errorLog.errc = ERROR_CODES[5]
      errorLog.errt = ERROR_TYPES.notSupport
      this.onOneError({
        errorType: errorLog.errt,
        code: errorLog.errc,
        url: err.url,
        headers: err.headers || {}
      }, 0)
      this._isOnePlayReport = true
      return
    }

    errorLog.errt = err.errorTypeCode ? err.errorTypeCode : err.errorType && ERROR_TYPES[err.errorType] ? ERROR_TYPES[err.errorType] : 9999
    if (err.errorCode) {
      errorLog.errc = err.errorCode > 0 ? ERROR_CODES[err.errorCode] : err.errorCode
    } else if (err.code && err.code > 0) {
      // code大于0 说明是video原生报错，需要转换为相关错误码
      errorLog.errc = ERROR_CODES[err.code] || err.code
    } else {
      errorLog.errc = err.code
    }

    errorLog.last_errors.push(errorLog.errc)

    if (errorLog.fir_errc === 0) {
      errorLog.fir_errc = errorLog.errc
    }
    this.onOnePlay(ENDED_TYPE.ERROR)
    this.onOneTemp(ENDED_TYPE.ERROR)
    this.sendDegradeLog('playCatch_end', this.playlogs.degrade)
    this.onOneError({
      errorType: errorLog.errt,
      code: errorLog.errc,
      url: err.url || '',
      headers: err.headers || {}
    })
    this.sendEventsQueue()
  }

  /**
   *
   * @param {*} info
   * {
   *      code:0,
   *      message: 'xxx',
   *     logid: 'xxxx',
   *     api: 'xxxx'，
   *     timestamep: 11111,
   *     error: { code: 'xxxx' }
   * }
   *
   */
  /** *Play接口错误上报 */
  onPlayInterfaceInfo = (info) => {
    log('onPlayInterfaceInfo', info)
    const { errorLog, apiLog, playlogs } = this
    if (info) {
      Object.keys(info).map(key => {
        if (key === 'code') {
          apiLog.vsc = info[key]
        } else if (key === 'message') {
          apiLog.vsc_message = info.message || 'success，视频可正常播放'
        } else {
          apiLog[key] = info[key]
        }
      })
    }
    playlogs.at = info.timestamep || new Date().getTime()
    // -9988 为dash_error 单独上报
    if ((info.error && info.error.errc === -9988)) return
    apiLog.vsc = info.code || 10
    apiLog.vsc_message = info.message || 'success，视频可正常播放'
    if (info.error) {
      const error = info.error
      errorLog.errt = 1000
      errorLog.errc = error.errc || -9998
      errorLog.last_errors.push(error.errc || -9998)
      if (errorLog.fir_errc === 0) {
        errorLog.fir_errc = error.errc || -9998
      }
      errorLog.accu_errc++
      if (errorLog.accu_errc === 1) {
        errorLog.fir_errt = nowTime()
      }
      this.onOneError({ errorType: 1000, code: error.errc || -9998, url: '', headers: {} })
    }
  }

  /**
   * 播放流程中的处理数据收集 通过event上报
   * 开发过程中一些特殊情况数据收集
   * end_type: progress
   */
  onProgressEvent = (data = {}) => {
    const { netLog } = this
    // 记录下载速度
    if (data.speed) {
      const speed = data.speed > 1000000 ? Math.floor(data.speed / 1000) : data.speed
      netLog.downloadSpeed = speed
      netLog.totalSpeed += speed
      netLog.rqCount++
    }

    data.type !== 'oversize' && netLog.requestCount++
    data.connectTime && (netLog.connectCost = data.connectTime)

    // 抽样发送埋点 10%
    const percent = netLog.rqCount < 7 ? 100 : (data.costTime >= 5000 ? 20 : 10)
    if (data.type === 'success' && parseInt(Math.random() * 100, 10) <= percent) {
      return;
    }

    const connectData = findPerformanceInfo(data.cdnUrl)
    const xhr = data.xhr || {}
    const type = data.type ? `progress_${data.type}` : 'progress'

    let headers = data.headers
    if (!headers) {
      headers = getResponseHeaders(xhr)
    }
    headers = transformHeader(headers)
    const ext = {
      ...headers,
      download_speed: netLog.downloadSpeed,
      connect_cost: netLog.connectCost,
      c_dur: connectData.connectDuration || 0,
      d_dur: connectData.domainDuration || 0,
      r_dur: connectData.duration || 0,
      rqtt: new Date().getTime(),
      x_cache: headers.x_response_cache || '',
      server_ip: headers.x_response_sinfo
    }
    if (data.status) {
      netLog.status = data.status
    } else if (xhr && xhr instanceof window.XMLHttpRequest) {
      netLog.status = xhr.status || 0
    }

    ext.status = netLog.status
    const url = data.cdnUrl || data.url
    if (data.type === 'error') {
      this.merror.cdn.push({
        costTime: data.costTime,
        cur_play_pos: data.pos,
        cdn_url: url,
        cdn_host: getHostFromUrl(url),
        ...ext,
        ...headers
      })
    }
    this.onOneEvent({
      costTime: data.costTime,
      vid: data.vid,
      end_type: type,
      cur_play_pos: data.pos,
      cdn_url: url,
      cdn_host: getHostFromUrl(url)
    }, ext, data.type === 'error' ? 0 : 2)
  }

  onNext = (type) => {
    log('onNext:startStep:', this.startStep)
    if (this.startStep > 0) {
      if (this._reportInvalidVV(ENDED_TYPE.NEXT)) {
        return;
      }
      this.onOnePlay(ENDED_TYPE.NEXT)
      this.onOneTemp(ENDED_TYPE.NEXT)
      this.sendEventsQueue()
    }
    this.vtype = null
    this.playlogs.lc = 0
    this.resetLoggerParams()
  }

  onNextEnded = () => {
    const { player, resLogs } = this
    let idf = player.config.defaultDefinition || ''
    idf = idf.replace('P', 'p')
    resLogs.initial_resolution = idf
    resLogs.final_resolution = idf
  }

  onSeeking = () => {
    if (checkVideoSrcIsEmpty(this.player.src) || checkIsEmptySrc(this.player, this.line_app_id)) return
    const { resLogs, playlogs, player, seekLog } = this
    log('onSeeking', `currentTime:${player.currentTime}`)
    // 解决非自动播放就seek的时候pt设置问题
    if (this.startStep === 0) {
      this.setPt()
    }
    // seek开始自动结束卡顿计算
    this.suspendWaitingStatus('seek')
    this.isSeeking && this.suspendSeekStatus('seek', false)
    this.isSeeking = true
    playlogs.played.push({
      begin: this.player.currentTime,
      end: -1
    })
    resLogs.played.push({
      begin: this.player.currentTime,
      end: -1
    })
    seekLog.lastSeekStartTime = nowTime()
    seekLog.seekBefore = this.lastVideoTime.toString()
    seekLog.intervalId = setTimeout(() => {
      if (this.isSeeking) {
        this.suspendSeekStatus('seekTimeout', true)
      }
    }, MAX_STALL_TIME)
  }

  onSeeked = () => {
    if (checkVideoSrcIsEmpty(this.player.src) || checkIsEmptySrc(this.player, this.line_app_id)) return
    if (this.isSeeking) {
      this.suspendSeekStatus('seeked', true)
    }
  }

  // 获取操作间隔,单位ms
  getLastInterval (key, context = this, refresh = true) {
    const val = context[key]
    const now = nowTime()
    const lastInterval = val === DEFAULT_INTERVAL ? DEFAULT_INTERVAL : (now - val)
    if (refresh) {
      context[key] = now
    }
    return lastInterval
  }

  updateSeekPt (refresh) {
    return this.getLastInterval('lastSeekStartTime', this.seekLog, refresh)
  }

  onPlaying = () => {
    this.suspendWaitingStatus('play')
    this.load_state = LOAD_STATES.PLAYABLE
    const now = nowTime()
    if (this.pauseLog.isPausing) {
      this.pauseLog.isPausing = false
      this.pauseLog.pause_acu_t += (now - this.pauseLog.pause_start)
    }
  }

  onPlayCatch = (type, error = { errorType: '', errorTypeCode: 0, errorCode: 0, url: '', headers: {}, status: 0 }) => {
    log('onPlayCatch', type, error)
    if (!type) {
      return
    }
    const { errorLog, playlogs, merror } = this
    merror.playCatch.push({
      errc: error.errorCode,
      errt: error.errorType,
      ...error.headers
    })
    this.setBr('playcatch')
    errorLog.accu_errc++
    errorLog.try_err_c++
    error.errorCode && errorLog.last_errors.push(error.errorCode)
    this.suspendWaitingStatus('playcatch')
    this.sendDegradeLog('playCatch', playlogs.degrade, { cdn_url: error.url })
    if (type === 'mp42dash') {
      this.vtype = 'DASH_2'
    } else if (type === 'dash2mp4') {
      this.vtype = 'MP4_2'
    }
    playlogs.degrade = type

    this.onOneError({
      errorType: error.errorTypeCode,
      code: error.errorCode,
      url: error.url || '',
      status: error.httpCode || error.status,
      headers: error.headers || {},
      vid: error.vid || this.vid,
      preload_hit: error.preloadHit || 0,
      preload_cached: error.preloadCached || 0,
      endState: ENDED_TYPE.PLAY_CATCH,
      costTime: error.costTime,
      message: error.message
    }, 0)
  }

  onMediaExpied = (error = { errorType: '', errorTypeCode: 0, errorCode: 0, url: '', headers: {}, status: 0 }) => {
    const { errorLog, playlogs } = this
    log('onMediaExpied', error)
    this.suspendWaitingStatus('expied')
    this.setBr('expied')
    errorLog.accu_errc++
    errorLog.try_err_c++
    errorLog.last_errors.push(error.errorCode)
    playlogs.at = new Date().getTime()
    this.merror.expied.push({
      errorType: error.errorTypeCode || error.errorType,
      code: error.errorCode,
      url: error.url || '',
      status: error.status,
      ...transformHeader(error.headers || {})
    })
    this.onOneError({
      errorType: error.errorTypeCode || error.errorType,
      code: error.errorCode,
      url: error.url || '',
      status: error.status,
      headers: error.headers || {}
    }, 0)
  }

  onLog = (data) => {
    log('onLog', data)
    const type = data.type
    delete data.type
    if (!type) {
      return
    }
    switch (type) {
    // 重试
    case LOGTYPES.RETRY:
      break;
    case LOGTYPES.ONETEMP:
      if (!this._templog) {
        this._templog = {}
      }
      this._templog = parseTempData(this._templog, data.data, data.action)
      // 存在字段，命中数据库缓存
      if (this._templog.preload_hit) {
        this._cacheFile = CACHE_FILE_TYPE.CACHED;
      }
      break;
    case LOGTYPES.ONEERROR:
      const { errorLog } = this
      errorLog.accu_errc++
      errorLog.try_err_c++
      this.setBr('mp4error')
      errorLog.last_errors.push(data.code)
      this.onOneError(data, 0)
      break;
    case LOGTYPES.ONEEVENT:
      const ret = formatData(data, { costTime: 'costTime', vid: 'vid', end_type: 'end_type', pos: 'cur_play_pos', cdnUrl: 'cdn_url' })
      if (ret.ext) {
        ['start', 'end'].map(key => {
          if (ret.ext[key]) {
            ret.ext[`ext_${key}`] = ret.ext[key]
            delete ret.ext[key]
          }
        })
      }
      this.onOneEvent(ret.data, ret.ext, 2)
      break;
    default:
    }
  }

  onPlay = () => {
    log('onPlay', `this.startStep :${this.startStep} this.isEnded:${this.isEnded}`)
    // 如果当前状态是播放完成状态，将一些标记复原
    if (this.isEnded) {
      this.resetLoggerParams()
      this.setPt()
    }
  }

  onPause = () => {
    log('onPause')
    const { pauseLog } = this
    pauseLog.isPausing = true
    pauseLog.pause_start = nowTime()
  }

  onWaiting = () => {
    const { stall } = this
    log('onWaiting>', `isSeeking:${this.isSeeking} startStep:${this.startStep} intervalId:${stall.intervalId}`)
    if (this.isSeeking || this.playlogs.vt === 0) {
      return
    }

    // 上一次的卡顿还没有结束
    if (this.inWaitingStart > 0) {
      return
    }

    if (stall.intervalId) {
      window.clearTimeout(stall.intervalId)
      stall.intervalId = null
    }

    this.inWaitingStart = nowTime()

    // 延迟200ms进入卡顿状态
    stall.intervalId = window.setTimeout(() => {
      const { stall } = this
      log(`stall.intervalId>>${stall.intervalId} cost: ${nowTime() - this.inWaitingStart}`)
      this._endType = 'wait'
      this.load_state = LOAD_STATES.STALLED
      // mp4播放才做检测
      if (this.vtype.indexOf('MP4') > -1 && this.player.currentTime > 10 && this.task) {
        this.triggerTask('waiting', this.initial_url)
        this.requestCount++
      }
      stall.stall_start = this.inWaitingStart
      if (stall.sc === 1) {
        stall.first_buf_startt = this.inWaitingStart
      }
      window.clearTimeout(stall.intervalId)
      stall.intervalId = null

      this.startWaitingStatus(this.inWaitingStart, nowTime() - this.inWaitingStart)
      // 开始进入卡顿超时记时
      stall.intervalId = setTimeout(() => {
        if (this.inWaitingStart > 0) {
          this.suspendWaitingStatus('waitTimeout')
        }
      }, MAX_STALL_TIME)
    }, MIN_WAITIONG)
  }

  onEnded = () => {
    if (!this.initial_url) {
      return;
    }
    const watchDur = computeWatchDur(this.playlogs.played)
    log('onEnded', `watchDur:${watchDur} vt:${this.vt} pt:${this.pt}`)
    this.isEnded = true
    const df = this.resLogs.df
    this.changeResolution(df, df, nowTime(), 'leave_switch')
    this.onOnePlay(ENDED_TYPE.ENDED)
    this.sendDegradeLog('playCatch_end', this.playlogs.degrade)
    this.onOneTemp(ENDED_TYPE.ENDED)
    this.sendEventsQueue()
    this.playlogs.lc++
    // this.resetLoggerParams()
  }

  /***
   *未起播，网络状态码为-1
   */
  _reportInvalidVV (endState) {
    if (this._isInvaidVV()) {
      this.onOneError({ endState, errorType: 9998, code: -1, url: this.url, headers: {} }, 0)
      this._isOnePlayReport = true
      return true;
    }
    return false
  }

  _isInvaidVV () {
    return this.vt === 0 && this.curStatus === -1;
  }

  onUnload = () => {
    // 离开页面未起播 不发送埋点
    if (this.startStep === 0 || !this.initial_url) {
      return; // 未起播 不上报
    }
    const playState = ENDED_TYPE.UNLOAD
    this.onOneTemp(playState)
    this.sendDegradeLog('playCatch_end', this.playlogs.degrade)
    if (this._reportInvalidVV(ENDED_TYPE.UNLOAD)) {
      return;
    }
    // disableLocalCache 表示是否使用localStorage进行缓存
    !this._options.disableLocalCache ? this.onOnePlay(playState, true) : this.onOnePlay(playState, false)
    // this.sendEventsQueue()
  }

  onVisibilitychange = () => {
    const { vt } = this.playlogs
    if (document.visibilityState === 'visible') {
      if (!vt) {
        this.setPt()
      }
    }
  }

  bindUnload () {
    if (this.sniffer.device === 'pc') {
      window.addEventListener('beforeunload', this.onUnload)
    } else if (this.sniffer.device === 'mobile') {
      window.addEventListener('pagehide', this.onUnload)
    }
    document.addEventListener('visibilitychange', this.onVisibilitychange)
    this.player.once('destroy', this.onDestroy)
  }

  onDestroy = () => {
    log(`onDestroy:this.startStep:${this.startStep} initial_url:${this.initial_url} ${!!this.initial_url}`)
    // 播放器销毁的时候，如果首帧已经开始了，算一次vv
    console.log('>>>onDestroy', this.startStep > 0 && !!this.initial_url)
    if (this.startStep > 0 && !!this.initial_url) {
      this.onOnePlay(ENDED_TYPE.DESTROY)
      this.onOneTemp(ENDED_TYPE.DESTROY)
      this.sendDegradeLog('playCatch_end', this.playlogs.degrade)
    }
    const df = this.resLogs.df
    this.changeResolution(df, df, nowTime(), 'leave_switch')
    this.sendEventsQueue()
    if (this.sniffer.device === 'pc') {
      window.removeEventListener('beforeunload', this.onUnload)
    } else if (this.sniffer.device === 'mobile') {
      window.removeEventListener('pagehide', this.onUnload)
    }
    document.removeEventListener('visibilitychange', this.onVisibilitychange)
    this.listeners.forEach(item => {
      this.player.off(item.evt, item.handler)
    })
    this.clearTimers()
    this.player.off('destroy', this.onDestroy)
    this.task && this.task.clear()
  }

  clearTimers () {
    const { seekLog, stall } = this
    seekLog.intervalId && window.clearTimeout(seekLog.intervalId)
    stall.intervalId && window.clearTimeout(stall.intervalId)
  }

  /**
   *
   * @param {string} endType 结束理性 playcatch-发生降级 playcatch-降级播放结束
   * @param {string} degrade 降级类型
   * @param {object} data 附加数据
   */
  sendDegradeLog (endType = 'playCatch', degrade = 'none', data = {}) {
    log('sendDegradeLog', endType, degrade, data)
    const { degradeLog, playlogs } = this
    if (degradeLog.hasSendEnd || (endType === 'playCatch_end' && degrade === 'none')) {
      return
    }
    if (endType === 'playCatch_end') {
      degradeLog.hasSendEnd = true
    }
    const bu_acu_t = this.bu_acu_t - degradeLog.bu_acu_t
    const watchDur = computeWatchDur(playlogs.played)
    this.onOneEvent({
      costTime: this.vd,
      vid: this.vid,
      end_type: endType, // 'playcatch',
      cur_play_pos: this.player.currentTime,
      cdn_url: data.url
    }, {
      degrade: degrade,
      vt: this.vt,
      pt: this.pt,
      fvt: this.fvt,
      bc: this.bc - degradeLog.bc,
      bu_acu_t: bu_acu_t > MAX_TIME ? 0 : bu_acu_t,
      watch_dur: watchDur - degradeLog.watch_dur,
      ...data
    }, 0)
  }

  /**
  *  一次播放上报
  * 整个播放生命周期只上报一次,播放结束（非循环），重新计数
  * @param {Int} endState 结束类型
  * @param {Boolean} isLeave 是否是页面重载引发
  */
  onOnePlay = (endState = 3, isLeave = false) => {
    log(`onOnePlay _isOnePlayReport:${this._isOnePlayReport} isLeave: ${isLeave} endState:${endState}`)
    if (this._isOnePlayReport) {
      return
    }
    const { errorLog, playlogs, abrInfo, resLogs, player, apiLog, pauseLog, stall, netLog } = this
    this._isOnePlayReport = true
    const watchDur = computeWatchDur(playlogs.played)
    const et = curTimestamp()

    let videoBufferTime = 0
    let audioBufferTime = 0
    const buffered = player.video && player.video.buffered // 最后一个缓冲视频范围的结尾，即缓冲完成的时长 单位s, X1000转换为ms
    if (buffered) {
      const len = buffered.length
      let cachedBufferTime = 0
      for (let i = 0; i < len; i++) {
        cachedBufferTime += buffered.end(i) - buffered.start(i)
      }
      videoBufferTime = audioBufferTime = cachedBufferTime * 1000
    }
    const params = {
      local_time: new Date().getTime(),
      log_type: 'video_playq',
      // 是否有插件加载异常，0是正常 1为异常
      plugin_exception: 0, // todo
      // 自研播放器创建异常
      player_create_exception: '', // todo
      v: this.vid, // video id，外部传入
      initial_url: this.initial_url,
      initial_host: this.initial_host,
      initial_ip: this.curHeaders.x_response_sinfo || 0,
      initial_type: this.initial_type,
      ...this.curHeaders,
      initial_resolution: resLogs.initial_resolution,
      final_resolution: resLogs.final_resolution,
      // play_timestamp,  用户启动本次播放的时间戳
      pt: this.pt,
      // prepare开始的时间戳，单位是毫秒
      prepare_start_time: playlogs.nt, // 暂时用启动播放时间戳
      // prepare结束时间戳
      prepare_end_time: playlogs.rt || curTimestamp(), // 暂时用启动播放时间戳
      // vv_time,  用户开始看到点播视频的第一帧画面的时间戳
      vt: this.vt,
      // wp_time用户没有播放点播视频就离开的时间，若未发生则是空,LWP（leave  without play），单位是毫秒
      lt: this.lt,
      // lpt lt与pt的差值，用于统计复用下未起播快速切换
      lpt: this.lpt,
      // 首帧耗时
      fvt: this.fvt,
      // buffer  finish time用户本次点播视频流加载结束的时间戳，单位是毫秒
      bft: this.bft, // 用户本次点播视频流加载结束时间戳
      // seek的次数
      sc: this.seekLog.sc,
      // 累计seek时长
      sat: this.seekLog.sat,
      // 网络卡顿次数，即出现Loading的次数，只统计main url的bc
      bc: this.bc,
      dbc: playlogs.dbc || 0,
      nbc: playlogs.nbc || 0,
      video_net_s: this.videoNetworkState,
      status: this.curStatus,
      // 第一次发生卡顿的时间
      first_buf_startt: stall.first_buf_startt,
      // 第一次卡顿结束时间
      first_buf_endt: stall.first_buf_endt,
      lc: playlogs.lc, // 循环播放次数为0
      // 累积网络卡顿时长
      bu_acu_t: this.bu_acu_t > MAX_TIME ? 0 : this.bu_acu_t,
      de_bu_acu_t: playlogs.de_bu_acu_t || 0,
      n_bu_acu_t: playlogs.n_bu_acu_t || 0,
      // 累积暂停时长
      pause_acu_t: pauseLog.pause_acu_t,
      // 退出时播放时播放进度, 单位毫秒
      cur_play_pos: this.cur_play_pos,
      // 退出时当前的加载状态(卡顿与否)
      load_state: this.load_state,
      // 退出时的播放状态
      playback_state: this.playback_state,
      // 结束类型
      end_state: endState,
      // 累积观看时长
      watch_dur: watchDur > MAX_TIME ? 0 : watchDur,
      // 切换清晰度的次数
      switch_resolution_c: this.switchResolutionCount,
      // 是否在onprepared之后自动start 是否自动播放
      is_start_play_automatically: this.isAutoplay,
      // 视频续播时的起始位置（用户上次看到的位置），单位ms
      start_time: this.start_time,
      // 是否播放完成
      finish: this.finish,
      // error_type，最终的错误类型，服务端据此统计总的失败率  0 无错误 1000 Play接口错误 1001 DNS错误 1002 Player内部错误 1003 CDN错误 9999 其他错误
      errt: errorLog.errt,
      // 最终错误码
      errc: errorLog.errc,
      // video status code  视频状态异常，play接口返回的视频状态码（0或者10为正常状态）
      vsc: apiLog.vsc,
      // play接口返回的视频状态异常信息
      vsc_message: apiLog.vsc_message,
      api_str: apiLog.api_str, // api请求链接
      auth: apiLog.auth || apiLog.logid, // api请求非时候token或者logid
      width: this.videoWidth,
      height: this.videoHeight,
      // 视频时长
      vd: this.vd,
      // 缓存时长
      video_length: videoBufferTime,
      audio_length: audioBufferTime,
      // 视频清晰度
      df: resLogs.df,
      // 视频当前清晰度
      lf: resLogs.lf,
      play_c: 0, // 本次setVideoID/DirectURL/..中的play次数写为0
      // 播放器实例创建完成时间
      player_created_t: this.player_created_t,
      // 抽刺出错时间
      fir_errt: errorLog.fir_errt,
      // 首次出错错误码
      fir_errc: errorLog.fir_errc,
      lv_method: 0, // 离开时调用的方式  "0 stop, 1 release, 2 release  async ,3 normal 4 error , 5 status excp ,6 reset"
      // 最后一次切换分辨率开始时间
      ldst: resLogs.ldst,
      // 最后一次切换分辨率完成时间
      ldet: resLogs.ldet,
      is_disable_short_seek: 0, // 播放器目前没有short_seek处理
      mute: this.mute,
      volume: this.volume,
      download_speed: this.task && this.task.speed ? this.task.speed : netLog.downloadSpeed,
      avg_speed: netLog.rqCount > 0 ? parseInt(netLog.totalSpeed / netLog.rqCount, 10) : 0,
      mdl_req_num: netLog.requestCount, // 网络请求次数
      watingcost: this.watingCost,
      br: playlogs.br, // 中断次数
      fbrt: playlogs.fbrt, // 第一次中断
      try_err_c: errorLog.try_err_c, // 重试次数
      accu_errc: errorLog.accu_errc, // 累计错误次数
      dash_pst: this.dash_pst,
      dash_wst: this.dash_wst,
      dash_wrt: this.dash_wrt,
      dash_ift: this.dash_ift,
      dash_cst: this.dash_cst,
      dash_spt: this.dash_spt,
      dash_break: player.dashBufferBreak === 2 ? 1 : 0,
      // eagleid: this.eagleid,
      merror: JSON.stringify(this.merror),
      ex: JSON.stringify(this.exInfo),
      bufs: JSON.stringify(this.buffers.allBuffer),
      vs: resLogs.vs,
      vds: resLogs.vds,
      vps: resLogs.vps,
      ...this.buffers.curBuffer,
      degrade: playlogs.degrade,
      cache_file: this._cacheFile
    }
    // 已经开始起播, 中途退出
    if (this.vt !== 0) {
      params.et = et
    }

    if (player && player.dashState) {
      params.dash_state = player.dashState;
    }

    ['drm_type', 'dynamic_type', 'enable_bash'].forEach((key) => {
      this.addIfExist(key, this._options, params)
    })
    // 设置abr信息
    if (player.abrInstance) {
      const abrInst = player.abrInstance
      abrInfo.abr_general_info = abrInst.generalInfo
      abrInfo.abr_event_info.video_exit = {
        local_time_ms: new Date().getTime(),
        buffer_length: abrInst.bufferLength,
        internet_speed: abrInst.downloadSpeed,
        now_bitrate: abrInst.nowBitrate,
        play_speed: this.player.playbackRate
      }
      if (abrInst.getAbrPlayInfo) {
        abrInfo.abr_play_info = abrInst.getAbrPlayInfo() // 时序日志转到播放器中处理
      }
      if (abrInst.getAbrVVStats) {
        const abrVVStats = abrInst.getAbrVVStats();
        Object.keys(abrVVStats).forEach((key) => {
          params[key] = abrVVStats[key]
        })
      }
    }
    abrInfo.abr_init_opts = this.player.config.autoBitrateOpts || {}; // 空配置启播后，改配置日志有问题，上传前重新赋值
    params.abr_info = JSON.stringify(this.abrInfo)
    if (isLeave) {
      this.reportLog(REPORT_EVENTS.ONE_PLAY, params, isLeave)
    } else {
      this.reportLog(REPORT_EVENTS.ONE_PLAY, params)
    }
  }

  /** *一次用户操作上报 */
  // eslint-disable-next-line camelcase
  onOneOperator ({ costTime, operaType, stateBefore, stateAfter, endType }, ext = {}, mode = 2) {
  // eslint-disable-next-line camelcase
    const last_interval = this.getLastInterval('lastOperaTime')
    const params = {
      local_time: new Date().getTime(),
      v: this.vid, // video id，外部传入
      opera_type: operaType,
      state_before: stateBefore,
      state_after: stateAfter,
      cost_time: costTime,
      end_type: endType || this.end_type,
      cdn_url: this.url,
      resolution: this.resolution,
      last_interval,
      bufs: JSON.stringify(this.buffers.allBuffer),
      video_pos: this.cur_play_pos,
      // buffer_time: this.buffer_time,
      retry_count: this.retry_count // 目前播放器没有重试逻辑
    }
    if (this.player && this.player.dashState) {
      params.dash_state = this.player.dashState
    }
    Object.keys(ext).map(key => {
      params[key] = ext[key]
    })
    this.addIfExist('drm_type', this._options, params)
    this.reportLog(REPORT_EVENTS.ONE_OPERA, params, mode)
  }

  /** 一次事件上报，卡顿等 */
  // eslint-disable-next-line camelcase
  onOneEvent = ({ costTime, vid, end_type, cur_play_pos, cdn_url, cdn_host }, ext, mode) => {
    const { curBuffer } = this.buffers
    const params = {
      local_time: new Date().getTime(),
      // video id，外部传入
      v: vid || this.vid,
      // 耗时
      cost_time: costTime,
      // 结束类型seek、switch、exit、wait、error、progress
      end_type: end_type || this.end_type,
      // 当前cdn地址
      cdn_url: cdn_url || this.url,
      cdn_host: cdn_host || '',
      initial_type: this.initial_type,
      resolution: this.resolution,
      // 当前倍速
      play_speed: this.playbackRate,
      // 距离起播时间间隔
      first_frame_interval: nowTime() - this.pt,
      // 距离上次切清晰度的时间间隔
      last_switch_interval: this.getLastInterval('lastSwitchStartTime', this.resLogs, false),
      // 距离上次seek操作的时间间隔
      last_seek_interval: this.updateSeekPt(false),
      // 上次同类型事件的时间间隔
      last_event_interval: this.getLastInterval('lastEventTime'),
      // 时间发生时视频进度
      video_pos: cur_play_pos || this.cur_play_pos,
      video_ready_s: this.videoReadyState,
      video_seeking: this.videoSeeking,
      video_paused: this.videoPaused,
      bufs: JSON.stringify(this.buffers.allBuffer),
      // 内部重试次数
      retry_count: this.retry_count, // 目前播放器没有重试逻辑
      at: this.playlogs.at, // 初始化时间戳
      stay_seconds: parseInt((new Date().getTime() - this.playlogs.at) / 1000, 10),
      preload_state: this.player ? (this.player.preloadState || 0) : 0, // 预加载状态，0没有 1队列中 2当前正在预加载
      ...curBuffer
    }
    if (end_type === 'waitstart' && typeof this._options.getPageFPS === 'function') {
      const fpsInfo = this._options.getPageFPS()
      params.cur_fps = fpsInfo.curFPS || 0
      params.avg_fps = fpsInfo.avgFPS || 0
    }
    if (this.player && this.player.dashState) {
      params.dash_state = this.player.dashState;
    }
    if (ext && typeof ext === 'object') {
      for (const key in ext) {
        !params[key] && (params[key] = ext[key])
      }
    }
    this.addIfExist('drm_type', this._options, params)
    this.reportLog(REPORT_EVENTS.ONE_EVENT, params, mode)
  }

  onOneTemp = () => {
    log('onOneTemp>>', !this._templog)
    if (!this._templog) {
      return
    }
    const { player, playlogs, pauseLog, errorLog, resLogs } = this
    const watchDur = computeWatchDur(playlogs.played)
    const params = {
      local_time: new Date().getTime(),
      ...this._templog,
      v: this.vid, // video id，外部传入
      initial_type: this.initial_type, // 初始起播类型
      // play_timestamp,  用户启动本次播放的时间戳
      pt: this.pt,
      // vv_time,  用户开始看到点播视频的第一帧画面的时间戳
      vt: this.vt,
      // wp_time用户没有播放点播视频就离开的时间，若未发生则是空,LWP（leave  without play），单位是毫秒
      lt: this.lt,
      // 首帧耗时
      fvt: this.fvt,
      // 网络卡顿次数，即出现Loading的次数，只统计main url的bc
      bc: this.bc,
      // 第一次发生卡顿的时间
      // 累积网络卡顿时长
      bu_acu_t: this.bu_acu_t > MAX_TIME ? 0 : this.bu_acu_t,
      // 累积暂停时长
      pause_acu_t: pauseLog.pause_acu_t,
      // 退出时播放时播放进度, 单位毫秒
      cur_play_pos: this.cur_play_pos,
      // 累积观看时长
      watch_dur: watchDur > MAX_TIME ? 0 : watchDur,
      // 是否播放完成
      finish: this.finish,
      // error_type，最终的错误类型，服务端据此统计总的失败率  0 无错误 1000 Play接口错误 1001 DNS错误 1002 Player内部错误 1003 CDN错误 9999 其他错误
      errt: errorLog.errt,
      // 最终错误码
      errc: errorLog.errc,
      // 视频时长
      vd: this.vd,
      // 视频清晰度
      df: resLogs.df,
      // 视频当前清晰度
      lf: resLogs.lf,
      br: playlogs.br, // 中断次数
      fbrt: playlogs.fbrt, // 第一次中断
      try_err_c: errorLog.try_err_c, // 重试次数
      accu_errc: errorLog.accu_errc, // 累计错误次数
      dash_break: player.dashBufferBreak === 2 ? 1 : 0,
      bufs: JSON.stringify(this.buffers.allBuffer),
      vs: resLogs.vs,
      vds: resLogs.vds,
      vps: resLogs.vps,
      ...this.buffers.curBuffer,
      degrade: playlogs.degrade
    }
    // 已经开始起播, 中途退出
    if (this.vt !== 0) {
      params.et = curTimestamp()
    }

    ['drm_type', 'dynamic_type', 'enable_bash'].forEach((key) => {
      this.addIfExist(key, this._options, params)
    })
    this.reportLog(REPORT_EVENTS.ONE_TEMP, params, 0)
    this._templog = null
  }

  /**
   * 一次错误上报
   * @param {Object} err 错误信息对象
   * type: 0 无错误
   *       1000 Play接口错误
   *       详见 ERROR_TYPES 枚举
   */
  onOneError (err = { errorType: 0, code: 0, url: '', headers: {}, costTime: 0, vid: '', message: '', preload_hit: 0, preload_cached: 0 }, mode = 0) {
    log('onOneError', err)
    const { errorLog, apiLog, resLogs, player, playlogs } = this
    const headers = transformHeader(err.headers || {})
    const params = {
      v: err.vid || this.vid, // video id，外部传入
      video_pos: this.cur_play_pos,
      local_time: new Date().getTime(),
      // 耗时
      cost_time: err && err.costTime ? err.costTime : 0,
      errt: err.errorType, // 错误类型
      errc: err.code, // 具体的错误码
      es: this.es, // error_stage出错时的播放阶段，beforePlay/playing
      cdn_url: err.url || '', // 出错的url地址
      bufs: JSON.stringify(this.buffers.allBuffer),
      // cdn_ip: '', //出错cdn ip
      resolution: resLogs.final_resolution, // 出错时的清晰度
      last_errors: errorLog.last_errors.join(';'), // 本次播放的所有错误码，用';'分割
      vsc: apiLog.vsc, // video status code  视频状态异常，play接口返回的视频状态码（0或者10为正常状态）
      vsc_message: err.message || apiLog.vsc_message, // play接口返回的视频状态异常信息
      server_ip: headers.x_response_sinfo || 0,
      initial_host: /^blob/.test(err.url) ? 'blob:' : getHostFromUrl(err.url),
      ...headers, // cdn服务端返回的client_ip
      cur_play_pos: this.cur_play_pos, // 当前视频播放时间
      ...this.buffers.curBuffer,
      degrade: playlogs.degrade,
      end_state: err.endState || ENDED_TYPE.ERROR,
      preload_hit: err.preload_hit,
      preload_cached: err.preload_cached
    }
    if (player && player.dashState) {
      params.dash_state = player.dashState;
    }
    this.addIfExist('drm_type', this._options, params)
    this.reportLog(REPORT_EVENTS.ONE_ERROR, params, mode)
  }

  /**
   * @param {*} evtName
   * @param {*} params
   * @param {*} mode 默认-0:立即发送  1:本地记录 下次发送 2:队列合并发送
   */
  reportLog (evtName, params, mode) {
    const { ABTestTag } = this.player
    !params.player_sessionid && (params.player_sessionid = this.sessionId)
    !params.web_url && (params.web_url = window.location.href);
    params.user_agent = navigator.userAgent
    params.dynamic_type = this.dynamicType
    ABTestTag !== undefined && ABTestTag !== null && (params.abtest_tag = ABTestTag)
    const options = this._options
    if (isObject(options)) {
    // 合并公共参数
      COMMON_KEYS.forEach((pkey) => {
        this.addIfExist(pkey, options, params)
      })
      params.vtype = this.vtype
    }

    if (mode === 1) {
      const key = evtName
      const obj = {}
      obj[key] = params
      LocalLog.set(obj)
      return;
    } else if (mode === 2) {
      this.addEventsQueue(evtName, params)
      return
    }
    if (this.player) {
      this.player.emit('abLog', evtName, params)
    }
    this.tracker(evtName, params)
  }

  addEventsQueue (eventName, params) {
    this.eventQueue.push({ event: eventName, params })
    if (this.eventQueue.length >= this._options.maxQueueCount) {
      this.sendEventsQueue()
    }
  }

  sendEventsQueue () {
    while (this.eventQueue.length > 0) {
      const item = this.eventQueue.pop()
      this.tracker(item.event, item.params)
    // this.player.emit('abLog', item.event, item.params)
    }
  }

  startWaitingStatus (startTime, costTime) {
    this.onOneEvent({ costTime, end_type: 'waitstart' }, {}, 2)
    this.appendStallInfo('start', startTime)
  }

  triggerTask (type = 'start', url) {
    log('triggerTask>>', type)
    url = url || this.player.src
    const isSrcEmpty = checkVideoSrcIsEmpty(url)
    !isSrcEmpty && this.vtype.indexOf('MP4') > -1 && this.task && this.task.trigger(url, type)
  }

  appendStallInfo (type = 'start', time, endType) {
    const { stall } = this.exInfo
    if (type === 'start') {
      if (stall.length > 6) {
        stall.splice(0, stall.length - 6)
      }
      const buf = this.buffers.curBuffer
      stall.push({
        start: time,
        end: -1,
        endType: 'waitstart',
        cost: 0,
        cur: this.cur_play_pos,
        buf_s: buf.buf_s_pos, // 缓存开始点
        buf_e: buf.buf_e_pos, // 缓存结束点
        buf_i: buf.buf_include // 当前缓存是否包含当前播放时间
      })
    } else if (type === 'end') {
      const i = stall.length - 1
      if (i < 0) {
        return
      }
      if (stall[i].end < 0) {
        stall[i].end = time
        stall[i].endType = endType
        stall[i].cost = time - stall[i].start
      }
    }
    log('appendStallInfo', stall)
  }

  suspendWaitingStatus (endType) {
    const now = nowTime()
    const { playlogs, resLogs, stall, inWaitingStart } = this
    if (inWaitingStart <= 0 || this.isSeeking || playlogs.vt <= 0) {
      return
    }
    log(`suspendWaitingStatus>>${endType}|costTime:${now - inWaitingStart} isSeeking:${this.isSeeking} vt:${playlogs.vt}`)
    this.appendStallInfo('end', now, endType)
    // 如果恢复和卡顿的时间差小于阈值 不计入卡顿
    if (now - inWaitingStart > MIN_WAITIONG) {
      const costTime = now - this.inWaitingStart
      // 累计网络卡顿时长 排除seek和首帧加载
      playlogs.bc++
      if (this.checkInBuffer(this.player.currentTime)) {
        playlogs.de_bu_acu_t += costTime
        playlogs.dbc++
      } else {
        playlogs.nbc++
        playlogs.n_bu_acu_t += costTime
      }
      resLogs.bc++
      playlogs.bu_acu_t += costTime
      resLogs.bu_acu_t += costTime
      stall.stall_end = now
      stall.stall_last_interval = stall.stall_end - stall.stall_start
      stall.stall_acc_time += stall.stall_last_interval
      if (stall.sc === 1) {
        stall.first_buf_endt = now
      }
      // abr 卡顿时数据统计
      if (this.player.abrInstance && !this.isSeeking && this.playlogs.vt) {
        const abrInst = this.player.abrInstance
        this.abrInfo.abr_event_info.video_stall.push({
          local_time_ms: new Date().getTime(),
          stall_duration: parseFloat((costTime / 1000).toFixed(2)), // 卡顿时长，单位s
          buffer_length: abrInst.bufferLength,
          internet_speed: abrInst.downloadSpeed,
          now_bitrate: abrInst.nowBitrate,
          play_speed: this.player.playbackRate,
          is_abr: abrInst.isCurrentInAbr ? 1 : 0 // 是否在abr档位
        })
      }
      this.onOneEvent({ costTime, end_type: endType || 'wait' }, {}, 2)
    }

    // 恢复状态
    this._endType = ''
    this.load_state = LOAD_STATES.PLAYABLE
    this.inWaitingStart = 0
    window.clearTimeout(stall.intervalId)
    stall.intervalId = null
  }

  suspendSeekStatus (endType, needSendLog = true) {
    if (!this.isSeeking) {
      return
    }
    const { seekLog, resLogs, player } = this
    const costTime = nowTime() - seekLog.lastSeekStartTime
    log('suspendSeekStatus>>', `${endType} currentTime:${player.currentTime} costTime:${costTime} sat:${seekLog.sat} resLogs.sat:${resLogs.sat}`)
    seekLog.intervalId && window.clearTimeout(seekLog.intervalId)
    seekLog.intervalId = null
    this.isSeeking = false
    const operaType = this._endType = 'seek'
    const stateBefore = seekLog.seekBefore
    const stateAfter = (player.currentTime || 0).toString()
    seekLog.sc++
    seekLog.sat += costTime > MAX_COST ? 0 : costTime
    resLogs.sc++
    resLogs.sat += costTime > MAX_COST ? 0 : costTime
    this.updateSeekPt(true)
    if (!this.closeSeekLog && needSendLog) {
      this.onOneOperator({ costTime, operaType, stateBefore, stateAfter, endType })
    }
  }

  setPt () {
    const { playlogs } = this
    this.startStep = 1
    // log(`isSeeking:${this.isSeeking} currentTime: ${this.player.currentTime} playlogs.pt:${playlogs.pt}`)
    if (!playlogs.pt && this.player.currentTime) {
      this.isSeeking = true
    }
    if (!playlogs.pt) {
      playlogs.pt = curTimestamp()
      log('setPt', `init pt :${playlogs.pt}, document.visibilityState:${document.visibilityState}`)
    }
  }

  setVt () {
    const { playlogs } = this
    if (this.startStep === 1) {
      if (!playlogs.vt) {
        playlogs.vt = curTimestamp()
        log('setVt: first frame inited', `vt-pt:${(playlogs.vt - playlogs.pt)} vt-nt:${playlogs.vt - playlogs.nt}`)
      }
      this.startStep = 2
    }
  }

  setBr (endType) {
    const { playlogs } = this
    if (playlogs.vt > 0) {
      if (playlogs.br === 0) {
        playlogs.fbrt = endType || ''
      }
      playlogs.br++
    }
  }

  // params start,较新URL
  get url () {
    const { player } = this
    return player && player.config ? player.config.url : ''
  }

  // video id
  get vid () {
    const { player } = this
    return player && player.config ? player.config.vid : ''
  }

  get bc () {
    return this.playlogs.bc
  }

  // eslint-disable-next-line camelcase
  get bu_acu_t () {
    return this.playlogs.bu_acu_t
  }

  // 启动播放的时间戳
  get pt () {
    return this.playlogs.pt || curTimestamp()
  }

  get vt () {
    // 如果pt为0，vt默认为空
    const { vt, pt } = this.playlogs
    return pt > 0 ? vt : 0
  }

  get fvt () {
    const { vt, pt } = this.playlogs
    if (vt > 0 && pt > 0) {
      return parseInt(vt - pt, 10)
    }
    return 0
  }

  get dash_pst () {
    return this.playlogs.dash_pst
  }

  get dash_wst () {
    return this.playlogs.dash_wst
  }

  get dash_wrt () {
    return this.playlogs.dash_wrt
  }

  get dash_ift () {
    return this.playlogs.dash_ift
  }

  get dash_cst () {
    return this.playlogs.dash_cst
  }

  get dash_spt () {
    return this.playlogs.dash_spt
  }

  get vd () {
    const { player } = this
    if (player.duration && typeof player.duration === 'number' && player.duration > 0) {
      return parseInt(player.duration * 1000, 10)
    } else if (player.config.duration && typeof player.config.duration === 'number') {
      return parseInt(player.config.duration * 1000, 10)
    }
    return 0
  }

  // eslint-disable-next-line camelcase
  get cur_play_pos () {
    return parseInt(this.player.currentTime * 1000, 10)
  }

  get volume () {
    return this.player.volume
  }

  // eslint-disable-next-line camelcase
  get buffer_time () {
    let buf = 0
    try {
      const range = this.player.getBufferedRange()
      buf = range[1] - range[0]
    } catch (e) {
      buf = 0
    }
    return buf
  }

  // eslint-disable-next-line camelcase
  get player_created_t () {
    return this._playerCreatedTime
  }

  get playbackRate () {
    return this.player.playbackRate
  }

  get mute () {
    return this.player.muted ? 0 : 1
  }

  get videoWidth () {
    const { player } = this
    return player && player.video ? player.video.videoWidth : 0
  }

  get videoHeight () {
    const { player } = this
    return player && player.video ? player.video.videoHeight : 0
  }

  get preload () {
    const { player } = this
    return player && player.video ? player.video.preload : false
  }

  // eslint-disable-next-line camelcase
  get initial_url () {
    const currentSrc = this.player.currentSrc
    if (currentSrc.indexOf('blob:') > -1 && this.urlLog.initial_url) {
      return this.urlLog.initial_url
    } else {
      return checkVideoSrcIsEmpty(currentSrc) || checkIsEmptySrc(this.player, this.line_app_id) ? '' : currentSrc
    }
  }

  // eslint-disable-next-line camelcase
  get initial_host () {
    const currentSrc = this.player.currentSrc
    if (currentSrc.indexOf('blob:') > -1 && this.urlLog.initial_host) {
      return this.urlLog.initial_host
    } else {
      return getHostFromUrl(checkVideoSrcIsEmpty(currentSrc) || checkIsEmptySrc(this.player, this.line_app_id) ? '' : currentSrc)
    }
  }

  get curHeaders () {
    const { player, task } = this
    if (player && player.__dash__ && player.__dash__.curReqVideoSegInfo) {
      const headers = player.__dash__.curReqVideoSegInfo.headers || {}
      return transformHeader(headers)
    } else if (task) {
      return task.headers
    }
    return {}
  }

  get curStatus () {
    const { task, vtype, netLog } = this
    if (vtype.indexOf('MP4') > -1) {
      return task ? task.status : 0
    } else {
      return netLog.status
    }
  }

  // eslint-disable-next-line camelcase
  get play_type () {
  // 0  表示点播
    return 0
  }

  // 清晰度 分辨率
  get resolution () {
    return this.resLogs.df
  }

  get sessionId () {
    return this._sessionId
  }

  // 是否播放完
  get finish () {
    return this.isEnded ? 1 : 0
  }

  // 结束类型
  // eslint-disable-next-line camelcase
  get end_type () {
    return this._endType
  }

  // 音频/视频的当前就绪状态
  get videoReadyState () {
    const { player } = this
    return player && player.video ? player.video.readyState : -1
  }

  // 显示出用户是否正在视频中寻址
  get videoSeeking () {
    const { player } = this
    return player && player.video && player.video.seeking ? 1 : 0
  }

  // 检查视频是否已暂停
  get videoPaused () {
    const { player } = this
    return player && player.video && player.video.paused ? 1 : 0
  }

  // 目前播放器没有重试逻辑
  // eslint-disable-next-line camelcase
  get retry_count () {
    return this._retryCount
  }

  get switchResolutionCount () {
    return this.resLogs.switch_count
  }

  get isError () {
    return this.util.hasClass(this.player.root, 'xgpplayer-is-error')
  }

  get isPlaying () {
    return this.util.hasClass(this.player.root, 'xgplayer-playing')
  }

  get isStop () {
    return this.util.hasClass(this.player.root, 'xgplayer-ended') || this.util.hasClass(this.player.root, 'xgplayer-nostart')
  }

  get isPause () {
    return this.util.hasClass(this.player.root, 'xgplayer-pause')
  }

  get isLoading () {
    return this.util.hasClass(this.player.root, 'xgplayer-isloading')
  }

  // error_stage出错时的播放阶段，beforePlay/playing
  get es () {
    return this.isPlaying ? 'playing' : 'beforePlay'
  }

  get lt () {
    let tmp = 0
    // 未起播率 进入页面初始化的时间点
    if (this.vt === 0) {
      log('lt init', this.playlogs.lt)
      tmp = curTimestamp()
    }
    return tmp
  }

  get lpt () {
    return this.lt ? this.lt - this.pt : 0;
  }

  // eslint-disable-next-line camelcase
  get playback_state () {
    if (this.isError) {
      return PLAYBACK_STATE.ERROR
    }
    if (this.isStop) {
      return PLAYBACK_STATE.STOP
    }
    if (this.isPause) {
      return PLAYBACK_STATE.PAUSE
    }
    if (this.isLoading) {
      return PLAYBACK_STATE.LOADING
    }
    return PLAYBACK_STATE.PLAYING
  }

  // eslint-disable-next-line camelcase
  get is_start_play_automatically () {
    return this.isAutoplay
  }

  get vtype () {
    return this.__vtype ? this.__vtype : (this.player.dash || (this.player.config && this.player.config.dashOpts && this.player.config.dashOpts.dynamic_video) ? 'DASH' : (this._options.vtype === 'DASH' ? 'MP4' : (this._options.vtype || 'MP4')))
  }

  set vtype (value) {
    this.__vtype = value
  }

  get watingCost () {
    if (this.inWaitingStart > 0) {
      const costTime = nowTime() - this.inWaitingStart
      return costTime > MAX_COST ? 0 : costTime
    } else {
      return 0
    }
  }

  get videoNetworkState () {
    const { player } = this
    return player && player.video ? player.video.networkState : -1
  }

  get eagleid () {
    const { player } = this
    if (player && player.__dash__ && player.__dash__.curReqVideoSegInfo) {
      const headers = player.__dash__.curReqVideoSegInfo.headers || {}
      return headers.eagleid
    }
    return ''
  }

  get initial_type () {
    const config = this.player.config || {}
    if (config && config.vodLogOpts && config.vodLogOpts.currentDashType !== undefined) {
      return parseInt(config.vodLogOpts.currentDashType, 10)
    }
    return -1
  }

  /**
   * range请求  segment_base
   * 分片文件请求 segment_template
   */
  get dynamicType () {
    const { player } = this
    if (this.__dt) {
      return this.__dt
    } else if (player && player.__dash__ && player.__dash__.dash && player.__dash__.dash.mpd) {
      this.__dt = player.__dash__.dash.mpd.dashType
      return this.__dt
    } else {
      return ''
    }
  }

  /**
   * 当前最近的buffer区间以及当前播放时间是否在buffer中
   */
  updateCurBuffer () {
    const { buffered, currentTime } = this.player
    const buffer = {
      buf_s_pos: 0, // 缓存开始点
      buf_e_pos: 0, // 缓存结束点
      buf_include: 0 // 当前缓存是否包含当前播放时间
    }
    const buffers = []
    if (!buffered || buffered.length < 1) {
      return buffer
    }
    let diff = -1, index = -1
    for (let i = 0; i < buffered.length; i++) {
      const start = parseInt(buffered.start(i) * 1000, 10)
      const end = parseInt(buffered.end(i) * 1000, 10)
      buffers.push({ start, end })
      if (currentTime > start && currentTime < end) {
        buffer.buf_include = 1
        buffer.buf_s_pos = start
        buffer.buf_e_pos = end
      } else {
        if (currentTime < start && (diff < 0 || start - currentTime < diff)) {
          diff = start - currentTime
          index = i
        } else if (currentTime > end && (diff < 0 || currentTime - end < diff)) {
          diff = currentTime - end
          index = i
        }
      }
    }
    if (buffer.buf_include !== 1 && index > -1) {
      buffer.buf_s_pos = parseInt(buffered.start(index) * 1000, 10)
      buffer.buf_e_pos = parseInt(buffered.end(index) * 1000, 10)
    }
    this.buffers.allBuffer = buffers
    this.buffers.curBuffer = buffer
  }

  checkInBuffer (currentTime, diff = 0) {
    const { buffered } = this.player
    currentTime = parseInt(currentTime * 1000, 10)
    for (let i = 0; i < buffered.length; i++) {
      const start = parseInt(buffered.start(i) * 1000, 10) + diff,
        end = parseInt(buffered.end(i) * 1000, 10) + diff
      if (currentTime > start && currentTime < end) {
        return true
      }
    }
    return false
  }

  updateVideoSize () {
    const { _options, player, resLogs } = this
    let vs = 0
    let bitrate = 0
    if (player.__dash__ && player.__dash__.dash && player.__dash__.dash.mpd.mediaList) {
      const videoList = player.__dash__.dash.mpd.mediaList.video;
      const videoItem = videoList[videoList.selectedIdx];
      log('updateVideoSize》》videoItem', videoItem)
      bitrate = videoItem ? (videoItem.bitrate || videoItem.bandwidth) : 0
      vs = videoItem ? videoItem.size : 0
    } else {
      vs = _options.videoSize || player.config.videoSize || 0
      bitrate = _options.bitrate || player.config.bitrate || 0
    }
    log('updateVideoSize', `bitrate:${bitrate}, vs:${vs}`)
    if (vs) {
      resLogs.vs = vs
      resLogs.vis = parseInt(vs / player.duration, 10)
      resLogs.bitrate = bitrate || resLogs.vis
    }
  }

  updateVds () {
    const { resLogs, playlogs, player } = this
    if (resLogs.vis === 0) {
      log('updateVds', `vis:${resLogs.vis}`)
      return
    }
    const pdur = parseInt(computeWatchDur(playlogs.played) / 1000, 10)
    const buf = player.buffered
    let bdur = 0
    for (let i = 0; i < buf.length; i++) {
      bdur += parseInt(buf.end(i) - buf.start(i), 10)
    }
    log('updateVds', `pdur:${pdur} bdur:${bdur} \n         lbuf:${resLogs.lbuf} lplayed:${resLogs.lplayed} bitrate: ${resLogs.bitrate} vis:${resLogs.vis} vs:${resLogs.vs}`)
    resLogs.vps += parseInt((pdur - resLogs.lplayed) * resLogs.vis, 10)
    resLogs.vds += parseInt((bdur - resLogs.lbuf) * resLogs.vis, 10)
    resLogs.lplayed = pdur
    resLogs.lbuf = bdur
  }
}
export default XGPlayerAppLogger
